import React from 'react';
import PropTypes from 'prop-types';
import { AngleUpIcon } from '../icons/AngleUpIcon';
import { AngleDownIcon } from '../icons/AngleDownIcon';
import CheckIcon from '../icons/CheckIcon';

// **********************************************************************************
// IMPORTANT - LATEST VERSION OF THIS COMPONENT CAN BE FOUND IN THE PICBLOG PROJECT
// I WOULD REFER TO THAT COMPONENT FOR THE LATEST COMMMENTS AND UPDATES. THE DOCUMENTATION
// THERE IS FAR MORE COMPREHENSIVE.
// **********************************************************************************
/* 
    This is a simple MultiSelect DrownDown. The drop down list is maintained on the parent
    or obtained from calling an API.  Default configuration for this component
    is a multi select dropdown that displays a header (with title of list) and list of items.
    When items are selected, a check mark appears next to each item. This allows user to select
    multiple items.
    In addition, you can set the "displayCount" property to show the count of items in the header.
    You can opt to show count of only items "selected" or count of "all" items in the list.

    These are other options that can be handled by the parent.
    1) Disabling item selection and checkmark. Do this when using DropDown as simple display list.
    2) Add a text button as the last entry. Enables user to take some  action on the list.
       Below this component, you'll find a commented sample of the TextButton method used to concat to 
       the list upon rendering. You add this method to the parent and call it when you
       pass your list prop, as follows: list= {yourList.concat(this.getTextButtonItem())}
    3) In addition, below this component, you'll find sample of the toggleSelected method you can use 
       on the parent. If you want to turn off select and checkmark, make toggleSelected an empty
       statement.

    How to change styles
    Note the dropdown container has a set of default styles for its various components. Via the component props, 
    you can use alternative styles for the various styling components. As of this writing, this component
    is providing 2 props: one for a header style alternative and one for a drop-down-list alternative.

    Note: the dropdown list passed to the component consist of an array of objects structured as follows:
    [{key: 0, title: "Daniel Borges (1) ", selected: false, listname: "contributors"}, .....]

    IMPORTANT: There is feature that closes the drop down when some one clicks anywhere outside of
       the component. I tried implmenenting react-onclickOutside, but  was not able to make it work.
       Another alternative can be found below: 
       https://medium.com/@pitipatdop/little-neat-trick-to-capture-click-outside-react-component-5604830beb7f
       I believe this is same approach: https://larsgraubner.com/handle-outside-clicks-react/
       This seems alot simpler. Should implement when I'm using 1 or 2 dropdowns on page.
       I chose NOT to use this feature for performance reasons as dropdown will be used across a large number 
       of rows. Having so many listeners to register and unregister may not be practical.
       See this link as well: http://www.syntaxbook.com/post/929O3-detect-click-outside-react-component
*/

export class DropDownMenu extends React.Component {

    constructor (props) {
        super(props);

        // Initialize first button as active and second button as shadow
        this.state = {
            listOpen: false,
            displayCount: "no",  /* Config option to show count of all items or selected items in the header. 
                                   Values are "no", "selected", or "all".  */  
            displayHeader: true
        }
    }

    toggleList = () => {
        this.setState(prevState => ({
             listOpen: !prevState.listOpen
        }))
    }

    /* toggles the selected property true/false for the key in listname provided */
    toggleSelected = (key, listName) => {
        this.props.toggleSelected(key, listName);
    }

    // handleClickOutside = () => {
    //     console.log("*********   C L I C K E D   O U T    S I D E   ********")
    //     this.setState({
    //           listOpen: false     
    //     })
    // }

    render() {

        /* get default values defined in the local state */
        let { listOpen, displayCount, displayHeader } = this.state;

        /* set up default classes */
        let headerClass = "drop-down-header";
        let ddListClass = "drop-down-list";

        /* get props */
        let list    = this.props.list;
        let title   = this.props.title || '';
        let altHeaderClass   = this.props.altHeaderClass || '';
        let altDDListClass   = this.props.altDDListClass || '';

        /* See if there are  class overrides */
        if (altHeaderClass) { headerClass = altHeaderClass}
        if (altDDListClass) { ddListClass = altDDListClass}

        /* If this is a config prop, handle default overrides here */
        if (this.props.config) {
            if (this.props.config.hasOwnProperty('displayCount'))  { displayCount  = this.props.config.displayCount };
            if (this.props.config.hasOwnProperty('displayHeader')) { displayHeader = this.props.config.displayHeader };
        }
           
        /* If display header is false, change title to the fist item's title and have it appear instead of the header title.
           In addition, slice off first item of the list so it does not repeat in the drop down.  */
        if (!displayHeader) {
            title = list[0].title;    /* assign first items title here */
            let listCopy = [...list]; /* make copy of list */
            list = listCopy.slice(1); /* slice off first item */
        }

        /* If displayCount is equal to "selected", then calculate number selected */
        let  numSelected = 0;
        if (displayCount === "selected") {
            /* Obtain number of items selected in order to show in header */
            list.map((item) => {item.selected && numSelected++;})
        }
   
        return (
        <div className="drop-down-container">
            <div className={`${headerClass}`} onClick={() => this.toggleList()}>
                {displayCount === "no" &&  <div className="drop-down-title">{title}</div>}
                {displayCount === "selected" && <div className="drop-down-title">{title}&nbsp;{numSelected === 0 ? '' : `(${numSelected})`}</div>}
                {displayCount === "all" &&  <div className="drop-down-title">{title}&nbsp;{list.length === 0 ? '' : `(${list.length})`}</div>}
                <div>
                    {listOpen
                        ? <AngleUpIcon />
                        : <AngleDownIcon />
                    }
                </div>
            </div>
            
            {listOpen &&  <ul className={`${ddListClass}`} >
                {list.map((item) => (
                <li className="drop-down-list-item" key={item.key} 
                    onClick={this.toggleSelected.bind(this, item.key, item.listname)} >
                    {item.title} {item.selected && <CheckIcon />}
                </li>
                ))}
            </ul>}
        </div>
        )
    }
}

DropDownMenu.propTypes = {
    title:          PropTypes.string,
    list:           PropTypes.array,
    toggleSelected: PropTypes.func,
    altHeaderClass: PropTypes.string,   /* alternate class for header or title component */
    altDDListClass: PropTypes.string,   /* alternate class for drop down list  component */
    config:         PropTypes.object
};

var clickOutsideConfig = {
    handleClickOutside: function(instance) {
      return DropDownMenu.handleClickOutside;
    }
};

export default DropDownMenu;
// export default onClickOutside(DropDownMenu, clickOutsideConfig);

/*
    THIS IS SAMPLE toggleSelected METHOD USED ON THE PARENT

// This is function called when user selects list item in the drop down list 
toggleSelected = (key, listname) => {
    // assign the name of the local state variable 
    let dropDownList = this.state[listname];  // this is same as this.state.listname 
    dropDownList[key].selected = !dropDownList[key].selected
    this.setState({
      [listname]: dropDownList
    })
  }


   THIS IS SAMPLE METHOD USED ON THE PARENT TO APPEND A TEXT BUTTON 
 getTextButtonItem = () => {

        // construct an array with one item to concat to list 
        let textButtonItem = [{
            key: 999,
            title: <TextButton text="Remove my name" myclassname="text-button-xxsmall" onClickHandler={() => {console.log("Remove my name")}} />
            // selected: false,
            // key: "location"
        }]
        return textButtonItem;
    }

   BELOW IS A SAMPLE DROP DOWN COMPONENT CALLING THE ABOVE METHOD TO CONCAT TO THE LIST AT RUN TIME
<DropDownMenu title="Names" list={ddlist.concat(this.getTextButtonItem())} toggleSelected={this.toggleSelected} />

    IF YOU DID NOT WANT TO DISPLAY HEADER , YOU WOULD ADD THE CONFIG PROP
<DropDownMenu title="Names" list={ddlist.concat(this.getTextButtonItem())} toggleSelected={ () => {;} } 
                                          config={{displayHeader: false}}/>

*/


// WEBPACK FOOTER //
// ./src/components/menus/DropDownMenu.js